import { NetworkConfig } from 'types/network';
import { CustomChainInfo } from './chainInfos';
import { networkInfo } from './constants';
import { CONVERTER_CONTRACT, MULTICALL_CONTRACT, ROUTER_V2_CONTRACT } from '@oraichain/oraidex-common';

export const network: CustomChainInfo & NetworkConfig = {
  ...networkInfo,
  prefix: networkInfo.bech32Config.bech32PrefixAccAddr,
  denom: 'orai',
  coinType: networkInfo.bip44.coinType,
  fee: { gasPrice: '0.00506', amount: '1518', gas: '2000000' }, // 0.000500 ORAI
  router: ROUTER_V2_CONTRACT,
  converter: CONVERTER_CONTRACT,
  multicall: MULTICALL_CONTRACT,
  explorer: 'https://scan.orai.io'
};
